import { ButtonProps, IconButton, SvgIcon, Tooltip } from '@mui/material'
import { IconCopy } from '@tabler/icons-react'
import { toast } from 'sonner'

export type CopyToClipboardIconButtonProps = {
  tooltip: string
  content: string
  onCopy?: () => void
} & ButtonProps

export const CopyToClipboardIconButton = ({
  tooltip,
  content,
  onCopy,
  ...props
}: CopyToClipboardIconButtonProps) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content)
      toast.info('Copied to clipboard!')
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
      toast.error('Failed to copy to clipboard')
    }
    onCopy?.()
  }

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={handleCopy} disableRipple {...props}>
        <SvgIcon fontSize="small">
          <IconCopy />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  )
}
